import { useState, createContext, useCallback, useMemo } from 'react';
import { Snackbar, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import MuiAlert from '@material-ui/lab/Alert';

const SnackbarContext = createContext({
  showSnackbar: () => null,
  hideSnackbar: () => null,
});

const useStyles = makeStyles((theme) => ({
  alert: {
    borderRadius: theme.shape.xxl,
    alignItems: 'center',
  },
}));

const initialState = {
  open: false,
  severity: 'success',
  message: '',
  code: null,
};

function SnackbarProvider({ children }) {
  const classes = useStyles();
  const [state, setState] = useState(initialState);

  const hideSnackbar = useCallback(() => {
    // need to use a functional update because of the closure
    // otherwise the function will not have access to the updated state
    setState((prevState) => ({ ...prevState, open: false }));
  }, []);

  const showSnackbar = useCallback(({ message, severity, code }) => {
    setState({ severity, message, open: true, code });
  }, []);

  const contextValue = useMemo(() => ({ showSnackbar, hideSnackbar }), [showSnackbar, hideSnackbar]);

  return (
    <SnackbarContext.Provider value={contextValue}>
      {children}
      <Snackbar open={state.open} autoHideDuration={4000} onClose={hideSnackbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <MuiAlert className={classes.alert} elevation={6} variant='filled' onClose={hideSnackbar} severity={state.severity}>
          {state.severity === 'error' && state.code ? `${state.code}: ${state.message}` : `${state.message}`}
        </MuiAlert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
}

SnackbarProvider.propTypes = {
  children: PropTypes.node,
};

export { SnackbarProvider };
export default SnackbarContext;
